import React, { Component, Fragment } from 'react';
import {
  translate
} from 'react-admin'; 
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import MultilineChart from '@material-ui/icons/MultilineChart';
import Timelapse from '@material-ui/icons/Timelapse';
import moment from 'moment'; //'../res/jssip';
import { configAPI } from '../config'
import Card from '@material-ui/core/Card';
import Trans from '../res/Trans'
import Checkbox from '@material-ui/core/Checkbox';
import Chart from 'react-apexcharts'
import PopUpTable from './PopUpTable';
import Button from '@material-ui/core/Button';
import { Paper, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit * 1,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit * 2
  }
});

const smalllist = { flex: 1, height: 100, width: 300, overflow: 'auto', background: '#ffffcc' };

class Stats extends Component {

  constructor(props) {
    super(props)
    const { translate } = this.props;
    this.state = {
      directMinutes: '',
      selectOptions: [],
      CircularProgressThickness: 0,
      // date1: new Date(),
      // date2: new Date(),
      checkboxs: [],
      table1: [],
      table2: [],
      header1: [],
      header2: [],
      options1: {
        title: {
          text: translate('trans.CallsPerX'),
          align: 'center'
        },
        chart: {
          stacked: true,
          //   stackType: '100%'
        },
        responsive: [{
          breakpoint: 480,
          options: {
            // legend: {
            //   position: 'bottom',
            //   offsetX: -10,
            //   offsetY: 0
            // }
          }
        }],
        xaxis: {
          categories: [],
        },
        yaxis: [{
          title: {
            text: translate('trans.DurationInSeconds'),
          },

        }, {
          opposite: true,
          title: {
            text: translate('trans.NumberOfCalls')
          }
        }],
        fill: {
          opacity: 1
        },
        // legend: {
        //   position: 'right',
        //   offsetX: 0,
        //   offsetY: 50
        // }
      },
      series1: [{
        name: translate('trans.Entries'),
        type: 'column',
        data: []
      }, {
        name: translate('trans.UniqueEntries'),
        type: 'column',
        data: []
      }, {
        name: translate('trans.TotalTime'),
        type: 'line',
        data: []
      }, {
        name: translate('trans.AvrageTime'),
        type: 'line',
        data: []
      }],

      options2: {
        title: {
          text: translate('trans.CallsPerMonth'),
          align: 'center'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          //   type: 'datetime',
          categories: [],
        },
        tooltip: {
          x: {
            // format: 'MM/yyyy'
          },
        }
      },
      series2: [{
        name: '',
        type: 'area',
        data: []
      }]
    }

    this.loadEXTS = this.loadEXTS.bind(this);

  }
  componentDidMount() {
    let today = moment(new Date()).format("YYYY-MM-DD");
    let yesterday = moment(new Date()).add(-90, 'days').format("YYYY-MM-DD");
    this.setState({ date1: yesterday });
    this.setState({ date2: today });
    // this.loadEXTS(yesterday, today, true);
    // this.loadLog();
  }

  getIncomingSum = (date1, date2) => {
    const request = new Request(configAPI.api.prod + '/GetIncomingSum?token=' + sessionStorage.B.encodeDecode()+'&from='+date1+'&to='+date2, {
      headers: new Headers({
        'Content-Type': 'text/json'
      }),
      method: 'GET'
    });

    fetch(request).then(response => { return response.json(); })
    .then(resp => {
        this.setState({directMinutes:resp.direct});                      
    })
  }

  loadEXTS = (date1, date2, init) => {
    
    this.setState({CircularProgressThickness: 3.6});

    if (date1 === null) date1 = this.state.date1;
    if (date2 === null) date2 = this.state.date2;

    var today = new Date();
    var startDate = moment(date1);
    var endDate = moment(date2);
    today = moment(new Date());
    if (endDate.isSameOrAfter(today)) endDate = today;
    var result = [];
    var months = [];

    if (endDate.isBefore(startDate)) {
      alert("End date must be greated than start date.")
    }

    while (startDate.isSameOrBefore(endDate)) {
      result.push(startDate.format("YYYY-MM"));
      months.push(startDate.format("MM/YYYY"));
      startDate.add(1, 'month');
    }

    this.setState({ months: months });
    var fullLog = '';
    result = result.map((date) => {
      let request = new Request(configAPI.api.prod + '/DownloadFile?&path=ivr2:Log/LogFolderEnterExit-' + date + '.ymgr&token=' + sessionStorage.B.encodeDecode(), {
        headers: new Headers({
          'Content-Type': 'text/json'
        }),
        method: 'GET'
      });

      return request;
    });
    Promise.all(result.map(url =>
      fetch(url)
        .then(url => url.text())
        .catch((err => { return console.log(err) }))
    ))
      .then(data => {
        data.forEach(element => {
          if (element) {
            fullLog += element;
          }
        });
        /// TODO: add a progress bar updated by loop
        var Newarray1 = [];
        var array1 = fullLog.split("\n");
        // stage 1: get basic array from log
        array1.forEach((value, index) => {
          value = value.replace(/[\r\n]+$/, ''); // remove line break at the end
          value = value.replace(/Folder#/g, ''); // remove line break at the end
          value = value.replace(/%.+?#/g, '%#'); // remove line break at the end
          // value += '%'; // add percent so next line will work for last value in line (that has no % after value)
          array1[index] = value.split('%#');
        });
        // stage 2: delete rows of irrelevant dates
        array1.forEach((value, index) => {
          if (value) {
            var regex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
            const dateIndex = value.findIndex(val => regex.test(val));
            if (dateIndex > 0) {
              var dateString = value[dateIndex];
              // "21/07/2019" --> 2019-07-21
              dateString = dateString.substr(6, 4) + "-" + dateString.substr(3, 2) + "-" + dateString.substr(0, 2);
              if (moment(dateString).isSameOrAfter(moment(date1)) && moment(dateString).isSameOrBefore(moment(date2))) Newarray1.push(array1[index]);
            }
          }
        });
        // stage 3 get list of extensions:
        this.setState({ Newarray1: Newarray1 });
        var array2 = [];
        Newarray1.forEach((value) => {
          if (value) {
            if (!(array2.includes(value[0]))) array2.push(value[0]); // add new extension
          }
        });
        var checkboxs = [];
        array2.forEach((value) => {

          if (value === '') value = 'ROOT';
          checkboxs.push(value);
        })

        this.setState({ checkboxs: checkboxs, CircularProgressThickness: 0 });
        
        if (init) {
          this.loadLog(checkboxs, months);
        }
      })

  };

  secToTime = (duration) => {
    var seconds = Math.floor((duration) % 60),
      minutes = Math.floor((duration / 60) % 60),
      hours = Math.floor(duration / (60 * 60));
  
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;
  
    return hours + ":" + minutes + ":" + seconds;
  }
  
  loadLog = (opts, months) => {
    var exts;
    var filteredArrayByExt = [];
    var totalTime = 0;
    var totalCalls = 0;
    var Newarray1 = this.state.Newarray1;
    var header1 = ['log.extentsion', 'log.totalCalls', 'log.uniqueCalls', 'log.totalTime', 'log.avrageTime'];
    var header2 = ['log.phones', 'log.totalTime'];
    var table1 = [];
    var table2 = [];
    var totalTimeArray = [];
    var avrageTimeArray = [];
    var totalTimePerMonth = [[0]];

    this.setState({open:false});

    if (opts.length !== undefined) exts = opts;
    else  exts = this.state.selectOptions;
    if (months === undefined) months = this.state.months;

    exts.forEach((ext, index) => {
      filteredArrayByExt = [];
      totalCalls = 0;
      Newarray1.forEach((val, i) => {
        if (val[0] === ext) {
          filteredArrayByExt.push(val);
          totalTime += parseInt(val[val.length - 1]);
          totalCalls++;
        }
      })

      var uniquePhone = [];
      var uniqueTime = [];
      filteredArrayByExt.forEach((val, i) => {
        if (uniquePhone.indexOf(val[1]) === -1) {
          uniquePhone.push(val[1]);
          uniqueTime.push(parseInt(val[val.length - 1]));
        }
        else {
          uniqueTime[uniquePhone.indexOf(val[1])] += parseInt(val[val.length - 1]);
        }
      });

      var avrg = (uniquePhone.length !== 0 ? Math.round(totalTime / uniquePhone.length) : 0);

      avrageTimeArray.push(avrg);
      totalTimeArray.push(totalTime);

      var avrgformatted = this.secToTime(avrg); //moment.utc(avrg * 1000).format('HH:mm:ss');
      var totalTimeformatted = this.secToTime(totalTime); //moment.utc(totalTime * 1000).format('HH:mm:ss');
      // reset var
      totalTime = 0;

      table1.push([ext, totalCalls, uniquePhone.length, totalTimeformatted, avrgformatted]);
      table2.push(['ext', ext]);
      for (var l = 0; l < uniquePhone.length; l++) {
        var uniqueTimeformatted = moment.utc(uniqueTime[l] * 1000).format('HH:mm:ss');
        table2.push([uniquePhone[l], uniqueTimeformatted]);
      }

      months.forEach((month, x) => {
        Newarray1.forEach((val, i) => {
          if (val[3].indexOf('/' + month) > 0) {
            if ((val[0] === ext) || (val[0] === '' && ext === 'ROOT')) totalTimePerMonth[index][x] = parseInt(totalTimePerMonth[index][x]) + parseInt(val[val.length - 1]);
          }
        });
        if (x < months.length - 1) totalTimePerMonth[index].push(0);
      });
      if (index < exts.length - 1) totalTimePerMonth.push([0]);
    });


    var perMonthSeries = [];
    exts.forEach((ext, index) => {
      perMonthSeries.push({ 'name': ext, 'data': totalTimePerMonth[index] })
    });

    this.setState({ header1: header1 });
    this.setState({ header2: header2 });
    this.setState({ table1: table1 });
    this.setState({ table2: table2 });
    var labels = [];
    table1.forEach(element => {
      if (!labels.includes(element[0])) labels.push(element[0]);
    });
    var dataTotal = [];
    var dataUnique = [];
    table1.forEach(element => {
      if (!dataUnique.includes(element[2])) dataUnique.push(element[2]);
    });
    table1.forEach(element => {
      if (!dataTotal.includes(element[1])) dataTotal.push(element[1]);
    });

    this.setState({
      options1: {
        stroke: {
          width: [0, 4]
        },
        chart: {
          stacked: false,
          stackType: '100%'
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        xaxis: {
          categories: labels,
        },
        fill: {
          opacity: 1
        },
      }
    });

    this.setState({
      series1: [{
        // name: translate('trans.Entries'),
        type: 'column',
        data: dataTotal
      }, {
        // name: translate('trans.UniqueEntries'),
        type: 'column',
        data: dataUnique
      }, {
        // name: translate('trans.TotalTime'),
        type: 'line',
        data: totalTimeArray
      }, {
        // name: translate('trans.AvrageTime'),
        type: 'line',
        data: avrageTimeArray
      }],
    });


    this.setState({
      options2: {
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          //   type: 'datetime',
          categories: months,
        },
        tooltip: {
          x: {
            // format: 'MM/yyyy'
          },
        }
      }
    });

    this.setState({
      series2: perMonthSeries,
    });

  };

  openStatOptions = () => {
    this.setState({ open: true,
                    selectOptions:[] });
  };
  openIncomingSumDialog = () => {
    this.setState({ openIncomingSumDialog: true});
  };

  openIncomingSumDialog

  handleClose = () => {
    this.setState({ open: false });
  };
  handleCloseSumDialog = () => {
    this.setState({ openIncomingSumDialog: false });
  };

  
  render() {
    const { translate, classes } = this.props;
    return (
      <Fragment>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <IconButton color="inherit" onClick={(e) => this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
          <div id="DatesExtensions" style={{ display: "inline-block" }}>
            <Trans variant="body2" text="trans.get_Statistics" />
            <div style={{ display: "inline-block", float: "right" }}>
              <input
                type="date"
                id="date1"
                value={this.state.date1}
                onChange={event => { this.setState({ date1: event.target.value }); 
                // this.loadEXTS(event.target.value, this.state.date2) 
              }}
              />
              <Trans variant="body2" text="trans.to" />
              <input
                type="date"
                id="date2"
                value={this.state.date2}
                onChange={event => { this.setState({ date2: event.target.value }); 
                // this.loadEXTS(this.state.date1, event.target.value) 
              }}
              />
            </div>
            <Button variant="extendedFab" color='primary' onClick={()=>this.loadEXTS(this.state.date1, this.state.date2) } >
                  {translate(`trans.choose_exts`)}
            </Button>
            <div>

              <div id="ExtensionList" style={{ float: "right" }}>
                <CircularProgress thickness={this.state.CircularProgressThickness}/>
                <Trans variant="body2" text="trans.extensions" />
                <Card style={smalllist}>
                  {
                    this.state.checkboxs.map((item) => (
                      <div ><Checkbox type='checkbox' id={item} value={item} onClick={(e) => {
                        // current array of selectOptions
                        const selectOptions = this.state.selectOptions
                        let index

                        // check if the check box is checked or unchecked
                        if (e.target.checked) {
                          // add the numerical value of the checkbox to selectOptions array
                          selectOptions.push(e.target.value)
                        } else {
                          // or remove the value from the unchecked checkbox from the array
                          index = selectOptions.indexOf(e.target.value)
                          selectOptions.splice(index, 1)
                        }

                        // update the state with the new array of selectOptions
                        this.setState({ selectOptions: selectOptions })
                      }
                      } />
                        <label for={item}>{item}</label></div>
                    ))
                  }

                </Card>
              </div>

            </div>
          </div>
          <Button color="primary" id="loadLog" onClick={this.loadLog} >
            {translate('trans.load_log')}
          </Button>

        </Dialog>
        <Dialog
          open={this.state.openIncomingSumDialog}
          onClose={this.handleCloseSumDialog}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth = {'xs'}
        >
          <IconButton color="inherit" onClick={(e) => this.handleCloseSumDialog(e)} aria-label="Close" style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
          <div id="DatesExtensions" style={{ display: "inline-block", padding:26 }}>
            <Trans variant="body2" text="trans.explainIncomingSum" />
            <div style={{ display: "inline-block", float: "right" }}>
              <input
                type="date"
                id="date1"
                value={this.state.date1}
                onChange={event => { this.setState({ date1: event.target.value }); 
                // this.loadEXTS(event.target.value, this.state.date2) 
              }}
              />
              <Trans variant="body2" text="trans.to" />
              <input
                type="date"
                id="date2"
                value={this.state.date2}
                onChange={event => { this.setState({ date2: event.target.value }); 
                // this.loadEXTS(this.state.date1, event.target.value) 
              }}
              />
            </div>
            <Button variant="extendedFab" color='primary' onClick={()=>this.getIncomingSum(this.state.date1, this.state.date2) } >
                  {translate(`trans.get_incomoingSum`)}
            </Button>
            <div>
            {(this.state.directMinutes!=='')&&(<><br/><br/><br/><Typography gutterBottom align="center" variant="display1">{translate(`trans.incoming_minutes`)}</Typography>
            <Typography gutterBottom align="center" variant="display1">{this.state.directMinutes}</Typography></>)}
            </div>
            </div>
        </Dialog>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <div style={{ display: 'flex', padding: '1em' }}>
                <Button variant="extendedFab" color='primary' onClick={this.openIncomingSumDialog} >
                  {translate(`trans.incoming_sum`)}<Timelapse />
                </Button>
                <Button variant="extendedFab" color='primary' onClick={this.openStatOptions} >
                  {translate(`trans.chart_settings`)}<MultilineChart />
                </Button>
                <PopUpTable name={'calls'} header1={this.state.header1} table1={this.state.table1} header2={this.state.header2} table2={this.state.table2} />
              </div>
              <Chart options={this.state.options1} series={this.state.series1} width={'100%'} height={300} />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Chart options={this.state.options2} series={this.state.series2} type="area" width={'100%'} height={300} />
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}


export default withStyles(styles)(translate(Stats));
